module.exports = __webpack_public_path__ + "static/media/benefits_preparing.041a8ea2.svg";